<section class="selectable-modal-wrapper">
  <div *ngIf="payload.showSelectable">
    <label>Selected</label>
    <gen-toggle-switch [active]="payload.selectedStatus"
                       (statusUpdate)="statusUpdate($event)"></gen-toggle-switch>
  </div>

  <gen-dynamic-form
    [popupMode]="payload.popupMode"
    [formConfig]="payload.formConfig"
    [formData]="formData"
    [formName]="payload.formId"
    [editMode]="payload.editMode"
    [overrides]="payload.overrides"
    [submitted]="submitted"
    [formVertical]="true"
    [disabled]="payload.disabled"
    (formChange)="updateFormData($event)"
    (validateChange)="valid = $event"
  ></gen-dynamic-form>

</section>
